/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Common_Custom_SpeedInputs */

const en_common_custom_speed = /** @type {(inputs: Common_Custom_SpeedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Custom Speed`)
};

const es_common_custom_speed = /** @type {(inputs: Common_Custom_SpeedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Velocidad personalizada`)
};

/**
* | output |
* | --- |
* | "Custom Speed" |
*
* @param {Common_Custom_SpeedInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const common_custom_speed = /** @type {((inputs?: Common_Custom_SpeedInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Common_Custom_SpeedInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_common_custom_speed(inputs)
	return en_common_custom_speed(inputs)
});